import { groupBy } from 'lodash';
import { Box } from '@mui/material';
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { Button, message, Spin, Tooltip } from 'antd';
import { TableStatusMap } from 'pages/globals/global';
import DataTable from 'components/LynDataTable/DataTable';
import controls from 'assets/images/icons/deactivated.svg';
import viewIcon from 'assets/images/table-icons/view_blue.svg';
import editIcon from 'assets/images/table-icons/edit_green.svg';
import IndeterminateCheckbox from 'components/@extended/IndeterminateCheckbox';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { useBulkActivationHrMasterMutation } from 'store/features/comptroller/comptrollerApi';

const ListViewEmployee = ({ hrEmployeeList, isLoading, setReloadTable, OrgStructureList }) => {
	const navigate = useNavigate();

	const [value, setValue] = useState(null);
	const [modalData, setModalData] = useState({});
	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState(null);
	const [submitForm, setSubmitForm] = useState(false);
	const [rowSelection, setRowSelection] = useState({});
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [existingPositionMap, setExistingPositionMap] = useState([]);

	// const [DeleteHrMaster, { data: deleteHrMaster }] = useDeleteHrMasterMutation();
	const [BulkActivationHrMasterHandle, { data: BulkActivationHrMasterRes }] = useBulkActivationHrMasterMutation();

	// const positionName = (val) => {
	//   for (let i = 0; i < OrgStructureList?.lynOrgStructModelDetailsFilled?.length; i++) {
	//     if (OrgStructureList?.lynOrgStructModelDetailsFilled[i]?.id === val) {
	//       return OrgStructureList?.lynOrgStructModelDetailsFilled[i]?.positionId + " - " + OrgStructureList?.lynOrgStructModelDetailsFilled[i]?.positionName;
	//     }
	//   }
	// };

	useEffect(() => {
		const arr = [];

		for (let i = 0; i < OrgStructureList?.lynOrgStructModelDetailsFilled?.length; i++) {
			arr[OrgStructureList?.lynOrgStructModelDetailsFilled?.[i]?.id] = OrgStructureList?.lynOrgStructModelDetailsFilled?.[i];
		}

		setExistingPositionMap(arr);
	}, [OrgStructureList]);

	useEffect(() => {
		if (rowSelection?.length) {
			let arr = [];

			rowSelection?.map((item) => {
				arr.push(item.original);
				return item;
			});

			const arr2 = groupBy(arr, ({ activationStatus }) => activationStatus);
			arr2['Inactive'] = arr?.filter(
				(item) => item?.activationStatus === 'Inactive' || item?.activationStatus === 'W-I-P' || item?.activationStatus === null
			);

			setSelectedRowKeys(arr2);
		}
	}, [rowSelection]);

	const deleteHandle = (data) => {
		setModalData({
			head: 'HR Master',
			//action: data?.length > 1 ? "delete all" : "delete"
			label:
				data?.length > 1 ? (
					<p>
						{' '}
						Do you want to <b style={{ fontSize: '1rem' }}>delete</b> all?
					</p>
				) : (
					<p>
						Do you want to <b style={{ fontSize: '1rem' }}>delete</b> this permanent employee?
					</p>
				),
		});

		setSubmitData(data);
		setShowModal(true);
	};

	const activeDeactiveHandle = (hrmasterStatus) => {
		let arr = [];

		if (hrmasterStatus === 'Active') {
			setValue('deactivated');
			setModalData({
				head: 'Function Master',
				action: rowSelection?.length > 1 ? 'deactivate all' : 'deactivate',
			});

			if (selectedRowKeys[hrmasterStatus]) {
				selectedRowKeys[hrmasterStatus]?.map((item) => {
					arr.push({
						id: item?.id,
						// companyCode: profileData?.creatorOrganizationId,
						parent: item?.parent ?? '',
						code: item?.code,
						name: item?.name,
						activationStatus: 'Inactive',
					});
					return item;
				});
			}
		} else if (hrmasterStatus === 'Inactive') {
			setValue('activated');
			setModalData({
				head: 'Function Master',
				action: rowSelection?.length > 1 ? 'activate all' : 'activate',
			});

			if (selectedRowKeys[hrmasterStatus]) {
				selectedRowKeys[hrmasterStatus]?.map((item) => {
					arr.push({
						id: item?.id,
						// companyCode: profileData?.creatorOrganizationId,
						parent: item?.parent ?? '',
						code: item?.code,
						name: item?.name,
						activationStatus: 'Active',
					});
					return item;
				});
			}

			if (selectedRowKeys['W-I-P']) {
				selectedRowKeys['W-I-P']?.map((item) => {
					arr.push({
						id: item?.id,
						// companyCode: profileData?.creatorOrganizationId,
						parent: item?.parent ?? '',
						code: item?.code,
						name: item?.name,
						activationStatus: 'Active',
					});
					return item;
				});
			}
		}

		if (arr?.length !== rowSelection?.length) {
			message.error({
				content: 'Your request is inconsistent with selection.',
				icon: <img src={controls} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
			});
		} else {
			setSubmitData(arr);
			setShowModal(true);
		}
	};

	useEffect(() => {
		if (submitData && submitForm) {
			let arr = [];
			submitData?.forEach((item) => {
				arr.push(item?.id);
			});

			BulkActivationHrMasterHandle({ data: arr, activationStatus: value === 'activated' ? 'Active' : 'Inactive' });
		} //eslint-disable-next-line
	}, [submitForm]);

	useEffect(() => {
		if (BulkActivationHrMasterRes?.status === 'SUCCESS') {
			let message = submitData?.length > 1 ? `Success! ${submitData?.length} rows ${value}` : `Success! ${submitData?.length} row ${value}`;

			toast.success(message, toastConfig);

			setReloadTable((val) => !val);
			setSubmitForm(false);
			setSubmitData(null);

			setValue(null);
		} else if (BulkActivationHrMasterRes?.status === 'FAILED') {
			toast.error('Function Master Status Updation Error!', toastConfig);
		}
		//eslint-disable-next-line
	}, [BulkActivationHrMasterRes]);

	const onUserSelect = (data) => {
		// Create a new object to avoid modifying the original data directly
		let item = { ...data };
		try {
			// Check if b64PicProfile is a string before parsing
			if (typeof item?.b64PicProfile === 'string') {
				item.b64PicProfile = JSON.parse(item.b64PicProfile);
			}
		} catch (error) {
			console.error('Error parsing JSON:', error);
			// Handle the error or log it based on your requirements
		}
		return item;
	};

	const activeInactiveStatus = (status) => {
		if (status === 'Active') {
			return (
				<Box style={{ backgroundColor: '#DBF7E2', color: '#30653D', textAlign: 'center', borderRadius: '5px', padding: '2px' }}>{status}</Box>
			);
		} else if (status === 'Inactive') {
			return (
				<Box style={{ backgroundColor: '#FFE2E2', color: '#BB2222', textAlign: 'center', borderRadius: '5px', padding: '2px' }}>{status}</Box>
			);
		} else if (status === 'W-I-P') {
			return (
				<Box style={{ backgroundColor: '#FDF7C4', color: '#694500', textAlign: 'center', borderRadius: '5px', padding: '2px' }}>{status}</Box>
			);
		}
	};

	const COLUMNS = useMemo(
		() => [
			{
				onClicked: true,
				align: 'center',
				id: 'Selection',
				cellAlign: 'center',
				Cell: ({ row, index }) => <IndeterminateCheckbox id={index} {...row.getToggleRowSelectedProps()} />,
				Header: ({ getToggleAllRowsSelectedProps }) => (
					<IndeterminateCheckbox sx={{ color: 'white', padding: '0px' }} {...getToggleAllRowsSelectedProps()} />
				),
			},
			// {
			//   Header: "Sl",
			//   accessor: (_, index) => index + 1,
			// },
			{
				Header: 'Employee ID',
				accessor: 'employeeId',
			},
			{
				Header: 'Name',
				accessor: 'entityFullName',
			},
			{
				Header: 'Email',
				accessor: 'entityEmail',
			},
			{
				Header: 'Mobile',
				accessor: 'entityPhoneNumber',
			},
			{
				Header: 'HR Position ID - Name',
				// accessor: (data) => positionName(data?.positionCode),
				accessor: (data) =>
					data?.positionCode
						? `${existingPositionMap?.[data?.positionCode]?.positionId} - ${existingPositionMap?.[data?.positionCode]?.positionName}`
						: 'No Position Assign',
			},
			// {
			//   Header: "Status",
			//   accessor: "entityStatus",
			// },
			{
				align: 'center',
				Header: 'Status',
				cellAlign: 'center',
				accessor: (data) => {
					return TableStatusMap[data?.activationStatus];
				},
				Cell: (cell) => {
					return activeInactiveStatus(TableStatusMap[cell.row.original.activationStatus]);
				},
			},
			{
				Header: 'Action',
				Cell: (cell) => (
					<div style={{ textAlign: 'center' }}>
						<Tooltip title="View">
							<Button
								type="text"
								icon={<img src={viewIcon} width={16} height={16} alt="view" />}
								onClick={(e) => {
									e.stopPropagation();
									navigate('/static/employee/details', {
										state: { OrgStructureList, employeeTableList: hrEmployeeList, userInfo: onUserSelect(cell.row.original) },
									});
								}}
							></Button>
						</Tooltip>

						<Tooltip title="Edit">
							<Button
								type="text"
								icon={<img src={editIcon} width={16} height={16} alt="edit" />}
								onClick={(e) => {
									e.stopPropagation();
									navigate('/static/employee/edit', {
										state: { OrgStructureList, employeeTableList: hrEmployeeList, userInfo: onUserSelect(cell.row.original) },
									});
								}}
							></Button>
						</Tooltip>

						{/* <Tooltip title="Delete">
              <Button
                type="text"
                icon={<img src={deleteIcon} width={16} height={16} alt="delete" />}
                onClick={(e) => {
                  e.stopPropagation();
                  deleteHandle([cell.row.original]);
                }}
              ></Button>
            </Tooltip> */}
					</div>
				),
				disableSortBy: 'true',
				align: 'center',
			},
		], //eslint-disable-next-line
		[OrgStructureList, hrEmployeeList, existingPositionMap]
	);

	return (
		<Spin spinning={isLoading}>
			<DataTable
				COLUMNS={COLUMNS}
				bulkDelete={false}
				DATA={hrEmployeeList}
				xlsxFileName="hr-master"
				deleteHandle={deleteHandle}
				rowSelection={rowSelection}
				setRowSelection={setRowSelection}
				activeDeactiveHandle={activeDeactiveHandle}
				onClickHandler={(row) => {
					navigate('/static/employee/details', {
						state: { OrgStructureList, employeeTableList: hrEmployeeList, userInfo: onUserSelect(row) },
					});
				}}
			/>

			{showModal && (
				<ComptrollerConfirmModal showModal={showModal} setShowModal={setShowModal} setSubmitForm={setSubmitForm} modalData={modalData} />
			)}
		</Spin>
	);

	// const [order] = useState("asc");
	// const [orderBy] = useState("trackingNo");

	// const headCells = [
	//   {
	//     id: "employee_id",
	//     align: "left",
	//     disablePadding: false,
	//     label: "Employee ID",
	//   },
	//   {
	//     id: "name",
	//     align: "left",
	//     disablePadding: true,
	//     label: "Name",
	//   },
	//   {
	//     id: "email",
	//     align: "left",
	//     disablePadding: false,
	//     label: "Email",
	//   },
	//   {
	//     id: "mobile",
	//     align: "left",
	//     disablePadding: false,
	//     label: "Mobile",
	//   },
	//   {
	//     id: "hr-position-code",
	//     align: "left",
	//     disablePadding: false,
	//     label: "HR Position Code",
	//   },
	//   {
	//     id: "status",
	//     align: "left",
	//     disablePadding: false,
	//     label: "Status",
	//   },
	//   {
	//     id: "action",
	//     align: "center",
	//     disablePadding: false,
	//     label: "Action"
	//   }
	// ];

	// return (
	//   <div style={{ marginTop: "1rem" }}>
	//     <MainCard content={false} sx={{ mt: 2 }}>
	//       <TableContainer
	//         sx={{
	//           width: "100%",
	//           overflowX: "auto",
	//           position: "relative",
	//           display: "block",
	//           maxWidth: "100%",
	//           "& td, & th": { whiteSpace: "nowrap" },
	//         }}
	//       >
	//         <Spin spinning={isLoading}>
	//           <Table
	//             aria-labelledby="tableTitle"
	//             sx={{
	//               "& .MuiTableCell-root:first-of-type": {
	//                 pl: 2,
	//               },
	//               "& .MuiTableCell-root:last-of-type": {
	//                 pr: 3,
	//               },
	//             }}
	//           >
	//             <TableHead>
	//               <TableRow style={{ backgroundColor: "#e5e5e5" }}>
	//                 {headCells.map((headCell) => (
	//                   <TableCell key={headCell.id} align={headCell.align || "left"} padding={headCell.disablePadding ? "none" : "normal"} sortDirection={orderBy === headCell.id ? order : false} sx={{width:"14.30%"}} >
	//                     {headCell.label}
	//                   </TableCell>
	//                 ))}
	//               </TableRow>
	//             </TableHead>
	//             <TableBody>
	//               {employeeList?.map((item) => {
	//                 return (
	//                   <TableRow
	//                     hover
	//                     role="checkbox"
	//                     sx={{ "&:last-child td, &:last-child th": { border: 0 }, cursor: "pointer" }}
	//                     tabIndex={-1}
	//                     key={item?.id}
	//                     onClick={(e) => {
	//                       e.stopPropagation();
	//                       onItemActionSelect({ item, type: "view" });
	//                     }}
	//                   >
	//                     <TableCell  align="left">{item?.employeeId}</TableCell>
	//                     <TableCell align="left">{item?.entityFullName}</TableCell>
	//                     <TableCell align="left">{item?.entityEmail}</TableCell>
	//                     <TableCell align="left">{item?.entityPhoneNumber}</TableCell>
	//                     <TableCell align="left">{positionName(item?.positionCode)}</TableCell>
	//                     <TableCell align="left">{item?.entityStatus}</TableCell>
	//                     <TableCell align="center">
	//                       <Tooltip title="View">
	//                         <Button
	//                           type="text"
	//                           style={{ margin: "3px" }}
	//                           icon={<img src={viewIcon} width={16} height={16} alt="view" />}
	//                           onClick={(e) => {
	//                             e.stopPropagation();
	//                             onItemActionSelect({ item, type: "view" });
	//                           }}>
	//                         </Button>
	//                       </Tooltip>
	//                       <Tooltip title="Edit">
	//                         <Button
	//                           type="text"
	//                           style={{ margin: "3px" }}
	//                           icon={<img src={editIcon} width={16} height={16} alt="edit" />}
	//                           onClick={(e) => {
	//                             e.stopPropagation();
	//                             onItemActionSelect({ item, type: "edit" });
	//                           }}>
	//                         </Button>
	//                       </Tooltip>
	//                       <Tooltip title="Delete">
	//                         <Button
	//                           type="text"
	//                           style={{ margin: "3px" }}
	//                           icon={<img src={deleteIcon} width={16} height={16} alt="delete" />}
	//                           onClick={(e) => {
	//                             e.stopPropagation();
	//                           }}>
	//                         </Button>
	//                       </Tooltip>
	//                     </TableCell>
	//                   </TableRow>
	//                 );
	//               })}
	//             </TableBody>
	//           </Table>
	//         </Spin>
	//       </TableContainer>
	//     </MainCard>
	//   </div>
	//   //  <Table scroll={{ x: 500 }} key="basic-hrmaster" dataSource={idividualList} columns={columns} pagination={false} />
	// )
};

export default ListViewEmployee;
